// extracted by css-extract-rspack-plugin
export default {"wrapper":"VacancyOfTheDayPage-module__wrapper--IT56o"};